import { Skeleton } from "@/components/ui/skeleton";

export const DashboardSkeleton = () => {
  return (
    <main className="flex-1 p-3 md:p-6 flex justify-center overflow-y-auto">
      <div className="w-full max-w-[1200px] space-y-3 md:space-y-5" role="status" aria-label="Ładowanie panelu">
        {/* Onboarding Progress skeleton */}
        <Skeleton className="h-16 w-full rounded-xl" />

        {/* Weekly Progress card */}
        <div className="space-y-3 md:space-y-4">
          <Skeleton className="h-28 w-full rounded-xl" />

          {/* Profile Stats card */}
          <div className="rounded-xl border border-border/50 p-4 space-y-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-12 w-12 rounded-full" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="space-y-2 p-3 rounded-lg bg-muted/30">
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-6 w-20" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Hot Info card */}
        <Skeleton className="h-20 w-full rounded-xl" />

        {/* Two-column grid: Competitors + Featured Ideas */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-5 pb-16">
          {/* Competitor Comparison */}
          <div className="rounded-xl border border-border/50 p-4 space-y-4">
            <Skeleton className="h-5 w-40" />
            <div className="space-y-3">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="flex items-center gap-3">
                  <Skeleton className="h-8 w-8 rounded-full" />
                  <div className="flex-1 space-y-1.5">
                    <Skeleton className="h-3 w-28" />
                    <Skeleton className="h-2 w-full rounded-full" />
                  </div>
                  <Skeleton className="h-4 w-12" />
                </div>
              ))}
            </div>
          </div>

          {/* Featured Ideas */}
          <div className="rounded-xl border border-border/50 p-4 space-y-4">
            <Skeleton className="h-5 w-36" />
            <div className="space-y-3">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="p-3 rounded-lg bg-muted/20 space-y-2">
                  <div className="flex items-center justify-between">
                    <Skeleton className="h-4 w-48" />
                    <Skeleton className="h-5 w-10 rounded-full" />
                  </div>
                  <Skeleton className="h-3 w-full" />
                  <Skeleton className="h-3 w-3/4" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
